import React from 'react'

export const AudioIndicator = ({
  isTranscribing
}: {
  isTranscribing: boolean
}) => {
  if (!isTranscribing) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 3.5C0.5 2.67157 1.17157 2 2 2C2.82843 2 3.5 2.67157 3.5 3.5V10.5C3.5 11.3284 2.82843 12 2 12C1.17157 12 0.5 11.3284 0.5 10.5V3.5Z"
          fill="#757575"
        />
        <path
          d="M5.5 1.5C5.5 0.671573 6.17157 0 7 0C7.82843 0 8.5 0.671573 8.5 1.5V12.5C8.5 13.3284 7.82843 14 7 14C6.17157 14 5.5 13.3284 5.5 12.5V1.5Z"
          fill="#757575"
        />
        <path
          d="M10.5 3.5C10.5 2.67157 11.1716 2 12 2C12.8284 2 13.5 2.67157 13.5 3.5V10.5C13.5 11.3284 12.8284 12 12 12C11.1716 12 10.5 11.3284 10.5 10.5V3.5Z"
          fill="#757575"
        />
      </svg>
    )
  }

  return (
    <video
      src="https://res.cloudinary.com/hellojoy/video/upload/v1752696324/images/telehealth-audio_ping-compressed.mp4"
      preload="auto"
      autoPlay
      loop
      muted
      width={16}
      height={16}
    />
  )
}
